import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const Testimonial = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  if (module.hideSection === "no") {
    return (
      <section
        className={`testimonial${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="testimonial-inner pt-70 pb-100 lgscreen:pt-30 lgscreen:pb-30 text-center">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                {module?.selectTestimonialCategory &&
                  module.selectTestimonialCategory.testimonials.nodes.map(
                    (item, i) => (
                      <div
                        className="w-full max-w-[746px] mx-auto lgscreen:px-20"
                        key={i}
                      >
                        {item.testimonialContent?.locationDetails && (
                          <motion.div
                            variants={animFade}
                            className="flex justify-center w-full gap-x-2 mb-20"
                          >
                            <div className="w-[15px]">
                              <img
                                src="../../../images/location-white.svg"
                                width={15}
                                height={15}
                                loading="lazy"
                                alt="location"
                                className="block ipad:hidden mt-[2px] mx-auto"
                              />
                            </div>
                            <p className="font-ositalic normal-case">
                              {item.testimonialContent.locationDetails}
                            </p>
                          </motion.div>
                        )}
                        {item?.content && (
                          <motion.h5
                            variants={animFade}
                            className="font-ositalic normal-case tracking-[0px] text-center"
                          >
                            {parse(item.content)}
                          </motion.h5>
                        )}
                        {item.testimonialContent?.authorName && (
                          <motion.h5
                            className="normal-case"
                            variants={animFade}
                          >
                            <span className="text-12 mt-20 inline-block tracking-[0em]">
                              {item.testimonialContent.authorName}
                              {item.testimonialContent?.authorLocation && (
                                <>, {item.testimonialContent.authorLocation}</>
                              )}
                            </span>
                          </motion.h5>
                        )}

                        {item.testimonialContent?.explore && (
                          <motion.div
                            variants={animFade}
                            className="flex justify-center mt-25 w-full"
                          >
                            <Link
                              to={item.testimonialContent.explore.url}
                              className="btn btn-black"
                              target={item.testimonialContent.explore.target}
                            >
                              Book Now
                            </Link>
                          </motion.div>
                        )}
                      </div>
                    )
                  )}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default Testimonial
export const EatDrinkTestimonialFragment = graphql`
  fragment EatDrinkTestimonialFragment on WpEatDrink_Restaurantcontent_RestaurantContent_Testimonial {
    extraId
    extraClass
    hideSection
    selectTestimonialCategory {
      testimonials {
        nodes {
          content
          testimonialContent {
            authorName
            authorLocation
            locationDetails
            explore {
              target
              title
              url
            }
          }
        }
      }
    }
  }
`
